import { createAsyncThunk } from "@reduxjs/toolkit";

export const deleteSomOfferMonitoring = createAsyncThunk("som/deleteSomOfferMonitoring", async (arg, { rejectWithValue, extra, getState }) => {
	try {
		const monitoringItemId = getState().som.deleteMonitoringConfirmDialog?.objectId;

		if (!monitoringItemId) return;

		const body = {
			action: "DELETE",
			monitoring_item_id: monitoringItemId,
		};

		const { data } = await extra.apiSom.postSomOfferMonitoring({ body });

		if (!data) {
			throw new Error();
		}

		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
